export const foldersConstants = {
  GET_FOLDERS_REQUEST: 'GET_FOLDERS_REQUEST',
  GET_FOLDERS_SUCCESS: 'GET_FOLDERS_SUCCESS',
  GET_FOLDERS_FAILURE: 'GET_FOLDERS_FAILURE',

  GET_FOLDER_DETAILS_REQUEST: 'GET_FOLDER_DETAILS_REQUEST',
  GET_FOLDER_DETAILS_SUCCESS: 'GET_FOLDER_DETAILS_SUCCESS',
  GET_FOLDER_DETAILS_FAILURE: 'GET_FOLDER_DETAILS_FAILURE',

  CREATE_FOLDER_REQUEST: 'CREATE_FOLDER_REQUEST',
  CREATE_FOLDER_SUCCESS: 'CREATE_FOLDER_SUCCESS',
  CREATE_FOLDER_FAILURE: 'CREATE_FOLDER_FAILURE',

  UPDATE_FOLDERS: 'UPDATE_FOLDERS',

  UPLOAD_DPE: 'UPLOAD_DPE',

  GET_FOLDER_FROM_BLOC: 'GET_FOLDER_FROM_BLOC',
  IGNORE_STALE_FOLDER_UPDATE: 'IGNORE_STALE_FOLDER_UPDATE',
  SET_ACTIVE_FOLDER: 'SET_ACTIVE_FOLDER',
};
